// Android notification channel for direct messages with the coach.
// Created once at app start. Other notification types stay on the default channel.

/** NotificationManager.IMPORTANCE_HIGH. Heads-up, sound, and it can peek. */
export const ANDROID_IMPORTANCE_HIGH = 4;

/** Notification.VISIBILITY_PUBLIC. The message shows in full on the lock screen. */
export const ANDROID_VISIBILITY_PUBLIC = 1;

export const COACH_DM_CHANNEL_ID = "coach_dms";

export const COACH_DM_CHANNEL = {
  id: COACH_DM_CHANNEL_ID,
  name: "Coach messages",
  description: "Direct messages with your coach. These stay loud.",
  importance: ANDROID_IMPORTANCE_HIGH,
  visibility: ANDROID_VISIBILITY_PUBLIC,
  // "default" is the phone's notification sound. Capacitor's sound field is a
  // res/raw filename, and a missing file mutes the channel, so createChannel
  // leaves sound unset and Android keeps this default.
  sound: "default",
  vibration: true,
  lights: true,
  lightColor: "#F5A400",
} as const;

export function coachDmChannelCreateArgs() {
  return {
    id: COACH_DM_CHANNEL.id,
    name: COACH_DM_CHANNEL.name,
    description: COACH_DM_CHANNEL.description,
    importance: COACH_DM_CHANNEL.importance,
    visibility: COACH_DM_CHANNEL.visibility,
    vibration: COACH_DM_CHANNEL.vibration,
    lights: COACH_DM_CHANNEL.lights,
    lightColor: COACH_DM_CHANNEL.lightColor,
  };
}
